import React from 'react';
import './MobileImageCarousel.css';

const slides = [
  "/choose1.jpeg",
  "/choose2.jpeg",
  "/choose3.jpeg",
  "/choose4.jpeg"
];

const MobileImageCarousel = () => {
  return (
    <div className="d-md-none px-3">
      <div 
        id="mobileCarousel" 
        className="carousel slide carousel-fade" 
        data-bs-ride="carousel" 
        data-bs-interval="2000"
      >
        <div className="carousel-inner rounded-4 shadow-lg overflow-hidden">
          {slides.map((src, index) => (
            <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
              <img src={src} alt={`Slide ${index + 1}`} className="carousel-img-only" />
            </div>
          ))}
        </div>

        {/* Optional Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#mobileCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#mobileCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileImageCarousel;
